import axios from 'axios';

// 创建axios实例
const service = axios.create({
  // baseURL: "//www.penya-sports.com",
  // baseURL: "//www.penya-sports.com",
  baseURL: "//www.pysport.cn",
  // baseURL: "http://pysport.com",
  timeout: 30000, // 响应时长
});
export default service;



// WEBPACK FOOTER //
// ./src/api/index.js